/**Data from this file is imported in search.component.ts */

import { Category } from '../../../../shared/interfaces/category-interface';
/** *Category Data Interface */
export const categories: Category[] = [
	{
		id: 1,
		name: $localize`:@@search_animalWarfare:Animal Welfare`,
		image: {
			src: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/animalWelfare1/public',
			alt: '',
		},
	},
	{
		id: 2,
		name: $localize`:@@search_artAndCulture:Art & Culture`,
		image: {
			src: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/art_And_Culture1/public',
			alt: '',
		},
	},
	{
		id: 3,
		name: $localize`:@@search_childWelfare:Child Welfare`,
		image: {
			src: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/childWelfare1/public',
			alt: '',
		},
	},
	{
		id: 4,
		name: $localize`:@@search_community:Community`,
		image: {
			src: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/community.1/public',
			alt: '',
		},
	},
	{
		id: 5,
		name: $localize`:@@search_education:Education`,
		image: {
			src: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/education1/public',
			alt: '',
		},
	},
	{
		id: 6,
		name: $localize`:@@search_emergencyRelief:Emergency Relief`,
		image: {
			src: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/emergencyRelief1/public',
			alt: '',
		},
	},
	{
		id: 7,
		name: $localize`:@@search_entrepreneurship:Entrepreneurship`,
		image: {
			src: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/entrepreneurship1/public',
			alt: '',
		},
	},
	{
		id: 8,
		name: $localize`:@@search_event:Event`,
		image: {
			src: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/event1/public',
			alt: '',
		},
	},
	{
		id: 9,
		name: $localize`:@@search_funeral:Funeral`,
		image: {
			src: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/funeral1/public',
			alt: '',
		},
	},
	{
		id: 10,
		name: $localize`:@@search_healthCare:Healthcare`,
		image: {
			src: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/healthcare1/public',
			alt: '',
		},
	},
	{
		id: 11,
		name: $localize`:@@search_housing:Housing`,
		image: {
			src: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/housing1/public',
			alt: '',
		},
	},
	{
		id: 12,
		name: $localize`:@@search_humanRights:Human Rights`,
		image: {
			src: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/humanRights1/public',
			alt: '',
		},
	},
	{
		id: 13,
		name: $localize`:@@search_food:Food`,
		image: {
			src: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/food1/public',
			alt: '',
		},
	},
	{
		id: 14,
		name: $localize`:@@search_natureAndEnvironment:Nature & Environment`,
		image: {
			src: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/nature&environment1/public',
			alt: '',
		},
	},
	{
		id: 15,
		name: $localize`:@@search_refugees:Refugees`,
		image: {
			src: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/refugees1/public',
			alt: '',
		},
	},
	{
		id: 16,
		name: $localize`:@@search_religion:Religion`,
		image: {
			src: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/religion1/public',
			alt: '',
		},
	},
	{
		id: 17,
		name: $localize`:@@search_sport:Sport`,
		image: {
			src: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/sports1/public',
			alt: '',
		},
	},
	{
		id: 18,
		name: $localize`:@@search_volunteer:Volunteer`,
		image: {
			src: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/volunter1/public',
			alt: '',
		},
	},
	{
		id: 19,
		name: $localize`:@@search_wedding:Wedding`,
		image: {
			src: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/wedding1/public',
			alt: '',
		},
	},
	{
		id: 20,
		name: $localize`:@@search_wish:Wish`,
		image: {
			src: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/wish1/public',
			alt: '',
		},
	},
	{
		id: 21,
		name: $localize`:@@search_womenEmpowerment:Women Empowerment`,
		image: {
			src: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/womenEnpowerment1/public',
			alt: '',
		},
	},
	{
		id: 23,
		name: $localize`:@@search_travelling:Travelling`,
		image:{
			src: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/travelling1/public',
			alt: '',
		}
	},
	{
		id: 22,
		name: $localize`:@@search_other:Other`,
		image: {
			src: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/other1/public',
			alt: '',
		},
	},
];
